import simbolo from './simbolo.webp';
import './marca.css';

/**
 * O símbolo do Ultima Idle: a rosa dos ventos com a seta do norte e o anel azul (techspec-marca).
 * A arte é um bitmap; `simbolo.webp` sai de docs/marca/fonte/preparar-simbolo.py, a mesma fonte do
 * favicon e das peças de divulgação. Ele é mais alto que largo e fica centrado na caixa que o CSS der.
 *
 * - `vivo`: o brilho azul respira devagar (tela de entrada, landing). Respeita "reduzir movimento".
 * - `titulo`: vira imagem com nome; sem ele, é decoração (o nome do jogo já está ao lado).
 */
export function SimboloMarca({ className, vivo = false, titulo }: {
  className?: string;
  vivo?: boolean;
  titulo?: string;
}) {
  const classes = ['mc', vivo ? 'mc--vivo' : '', className ?? ''].filter(Boolean).join(' ');
  return <img className={classes} src={simbolo} alt={titulo ?? ''} aria-hidden={titulo ? undefined : true} draggable={false} decoding="async" />;
}
